/* Presentation only: Rapi remains responsible for quantities, discounts and cart. */
(()=>{
  const states=new Map();
  const money=new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'});
  const text=(root,selector,value)=>{
    const element=root.querySelector(selector);
    if(element&&element.textContent!==value)element.textContent=value;
  };
  function init(){
    states.forEach((state,element)=>{if(!element.isConnected){state.observer.disconnect();states.delete(element);}});
    const config=document.getElementById('novasoin-pack-presentation');
    if(!config||config.dataset.enabled!=='true')return;
    const product=document.querySelector('.shopify-section[id$="__produit"]');
    if(!product)return;
    if(states.has(product)){states.get(product).render();return;}
    const offers=[...config.content.querySelectorAll('[data-pack-index]')].map(e=>({...e.dataset}));
    const gallery=()=>product.querySelector('splide-component[data-image-slider="true"]');
    const slides=()=>[...(gallery()?.querySelectorAll('.splide__list > .splide__slide:not(.splide__slide--clone)')||[])];
    const labels=()=>[...product.querySelectorAll('.rapi-bundles__bar-container')].filter(label=>label.querySelector('.rapi-bundles__bar-main'));
    const offerIndex=element=>offers.findIndex(offer=>element.querySelector('.rapi-bundles-deal-'+offer.packIndex));
    const showPhoto=index=>{
      if(config.dataset.sync!=='true'||!offers[index])return;
      const position=Number(offers[index].slide)-1;
      const button=gallery()?.querySelectorAll('.splide__pagination__page')[position];
      if(button&&!button.classList.contains('is-active'))button.click();
    };
    function render(){
      const photos=slides();
      offers.forEach(offer=>{
        const card=product.querySelector('.rapi-bundles-deal-'+offer.packIndex);
        if(!card)return;
        card.classList.add('ns-pack-card');
        const label=card.closest('.rapi-bundles__bar-container');
        label?.classList.add('ns-pack-option');
        const input=label&&document.getElementById(label.htmlFor);
        if(label){label.setAttribute('role','radio');label.setAttribute('aria-checked',String(!!input?.checked));label.tabIndex=input?.checked?0:-1;}
        text(card,'.rapi-bundles__bar-title p',offer.title);
        text(card,'.rapi-bundles__bar-subtitle p',offer.description);
        const price=card.querySelector('.rapi-bundles__bar-price')?.textContent||'';
        const amount=Number(price.replace(/[^\d,.-]/g,'').replace(',','.'));
        if(Number.isFinite(amount)&&amount>0)text(card,'.rapi-bundles__bar-label p',money.format(amount/Number(offer.quantity))+' / ruban');
        if(offer.packIndex==='2'&&label)text(label,'.rapi-bundles__bar-most-popular__content p',config.dataset.ribbon||'Meilleur prix par ruban');
        const source=photos[Number(offer.slide)-1]?.querySelector('img');
        if(!source)return;
        let thumb=card.querySelector('.ns-pack-thumb');
        if(!thumb){thumb=document.createElement('img');thumb.className='ns-pack-thumb';thumb.width=56;thumb.height=56;thumb.alt='';thumb.loading='lazy';thumb.decoding='async';card.insertBefore(thumb,card.children[1]||null);}
        const url=new URL(source.getAttribute('src'),document.baseURI);url.searchParams.set('width','160');
        if(thumb.getAttribute('src')!==url.href)thumb.setAttribute('src',url.href);
      });
      const bundle=product.querySelector('.rapi-bundles');
      if(bundle){bundle.setAttribute('role','radiogroup');bundle.setAttribute('aria-label','Choisissez votre quantité');}
    }
    let frame=0;
    const schedule=()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=0;render();});};
    const observer=new MutationObserver(records=>{
      if(records.some(record=>{
        const element=record.target.nodeType===1?record.target:record.target.parentElement;
        return element?.closest('.rapi-bundles')||[...record.addedNodes].some(node=>node.nodeType===1&&(node.matches('.rapi-bundles')||node.querySelector('.rapi-bundles')));
      }))schedule();
    });
    observer.observe(product,{subtree:true,childList:true,characterData:true});
    // Capture before the embedded widget handles/stops its own events.
    product.addEventListener('click',event=>{
      const label=event.target.closest('.rapi-bundles__bar-container');
      if(!label)return;
      const index=offerIndex(label);
      if(index>=0)requestAnimationFrame(()=>{render();showPhoto(index);});
    },true);
    product.addEventListener('change',event=>{
      if(!event.target.matches('input[type="radio"][id^="rapi-bundles-deal-"]'))return;
      const label=labels().find(item=>item.htmlFor===event.target.id);
      if(label)requestAnimationFrame(()=>{render();showPhoto(offerIndex(label));});
    },true);
    product.addEventListener('keydown',event=>{
      const label=event.target.closest('.ns-pack-option');if(!label)return;
      const all=labels();let next=all.indexOf(label);
      if(['ArrowDown','ArrowRight'].includes(event.key))next=(next+1)%all.length;
      else if(['ArrowUp','ArrowLeft'].includes(event.key))next=(next+all.length-1)%all.length;
      else if(event.key!==' '&&event.key!=='Enter')return;
      event.preventDefault();all[next].click();all[next].focus();
    });
    states.set(product,{observer,render});render();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
